import { callApiAsync, getInternalClientSatisfactionData } from '../../../services/apiService'

export const fetchTableData = async (
    orderNumber,
    quarter,
    year,
    page,
    pageSize,
    setTableData,
    setTotalRecords,
    setLoading
) => {
    await callApiAsync(
        () => getInternalClientSatisfactionData(orderNumber, quarter, year, page, pageSize),
        (resp) => {
            const data = resp?.data ?? resp;

            const items = Array.isArray(data?.data)
                ? data.data
                : Array.isArray(data?.items)
                    ? data.items
                    : Array.isArray(data)
                        ? data
                        : [];

            const total = Number(data?.total) || Number(data?.totalRecords) || items.length;

            setTableData(items);
            setTotalRecords(total);
        },
        setLoading
    );
};

export const fetchOrderNumbers = async (setOrderNumberOptions) => {
    await callApiAsync(
        () => getInternalClientSatisfactionData(null, null, null, 1, 1000),
        (resp) => {
            const data = resp?.data ?? resp;
            const items = Array.isArray(data?.data)
                ? data.data
                : Array.isArray(data?.items)
                    ? data.items
                    : Array.isArray(data)
                        ? data
                        : [];

            const uniqueOrderNumbers = [...new Set(items.map(item => item.orderNumber).filter(Boolean))];
            setOrderNumberOptions([
                { name: "Seleccionar", value: null },
                ...uniqueOrderNumbers.map(orderNum => ({ name: String(orderNum), value: orderNum }))
            ]);
        },
        null
    );
};
